import * as React from "react"
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner } from "sonner"

// lib/theme.js is the single source of truth for the *applied* theme: every
// Light/Dark/System switch runs applyTheme(), which toggles the `.dark` class
// on <html>. Mirror that resolved class rather than the stored mode. Reading
// the mode (getTheme) misses a System->explicit switch that resolves to the
// same scheme -- System-dark -> Dark leaves the class unchanged and updates
// only localStorage, which emits no same-tab DOM signal, so the observer never
// fires -- and it would leave Sonner on the ambiguous "system" value that can
// later drift from the user's explicit choice when the OS scheme changes. The
// resolved light/dark value always matches what the app actually renders, and
// the class observer keeps it in sync (including System following the OS, since
// initTheme's media listener re-toggles the class).
const getResolvedTheme = () =>
  document.documentElement.classList.contains("dark") ? "dark" : "light"

const Toaster = ({ ...props }) => {
  const [theme, setTheme] = React.useState(getResolvedTheme)

  React.useEffect(() => {
    const root = document.documentElement
    const sync = () => setTheme(getResolvedTheme())
    const observer = new MutationObserver(sync)
    observer.observe(root, { attributes: true, attributeFilter: ["class"] })
    sync()
    return () => observer.disconnect()
  }, [])

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        }
      }
      {...props}
    />
  )
}

export { Toaster }
